/**
 * API Configuration
 * This file is a template that gets replaced during the build process
 * DO NOT MODIFY THIS FILE DIRECTLY - it will be overwritten
 */

export const API_CONFIG = {
  // Career Feed API URL - will be replaced during build
  CAREER_FEED_API_URL: 'https://api.uncola.ai',
  
  // Bedrock API URL - will be replaced during build
  BEDROCK_API_URL: 'https://api.uncola.ai/bedrock',
  
  // Reports API URL - will be replaced during build
  REPORTS_API_URL: 'https://api.uncola.ai/reports',
  
  // Dashboard API URL - will be replaced during build
  DASHBOARD_API_URL: 'https://api.uncola.ai/dashboard-api',
  
  // Add other API endpoints as needed
  // EXAMPLE_API_URL: '{{EXAMPLE_API_URL}}',
};
